import { default as Axios } from 'axios'

const axios = Axios.create( {
  baseURL: 'https://lk.cred-it.ru/api/'
} )

export default axios